import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {FPNetDate} from "@commons/types";
import {IndiceMese} from "@commons/types";

export interface CalendarioChiusureAnnoRecord extends URIAndTrace {
    idAzienda: number | null,
    idCalendario: number | null,
    anno: number | null,
    data01: FPNetDate,
    data02: FPNetDate,
    data03: FPNetDate,
    data04: FPNetDate,
    data05: FPNetDate,
    data06: FPNetDate,
    data07: FPNetDate,
    data08: FPNetDate,
    data09: FPNetDate,
    data10: FPNetDate,
    data11: FPNetDate,
    data12: FPNetDate,
}

export class CalendarioChiusureAnnoRecord {

    static getScadenza = function (calendario: CalendarioChiusureAnnoRecord, index: IndiceMese) {
        switch (index) {
            case 1:
                return calendario.data01;
            case 2:
                return calendario.data02;
            case 3:
                return calendario.data03;
            case 4:
                return calendario.data04;
            case 5:
                return calendario.data05;
            case 6:
                return calendario.data06;
            case 7:
                return calendario.data07;
            case 8:
                return calendario.data08;
            case 9:
                return calendario.data09;
            case 10:
                return calendario.data10;
            case 11:
                return calendario.data11;
            case 12:
                return calendario.data12;
        }
        return null;
    }
}